module.exports = __webpack_public_path__ + "static/media/loader-rocket.6b6b8b61.png";